export default "__VITE_ASSET__DEyJXi1K__"